import { Http } from '@/lib/http';

export class LoanReviewChecklistService extends Http {
  endpoint = 'loan-pro/settings/loan-checklists';

  constructor() {
    super();
  }

  fetchChecklists() {
    return this.httpClient().get(this.endpoint);
  }

  createChecklist(newChecklist) {
    return this.httpClient().post(this.endpoint, newChecklist);
  }

  updateChecklist(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  deleteChecklist(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }
}
